import React from 'react';
import { Route, Router } from 'react-router-dom';
import Loadable from 'react-loading-overlay';
import { DashboardScreen } from '../../dashboard/DashboardScreen';
import { PsRoutes } from './Routes';
import AlertComponent from '../alert/AlertComponent';
import ProfileScreen from '../../profile/screens/ProfileScreen';
import ChangePasswordScreen from '../../profile/screens/ChangePasswordScreen';
import { connect } from 'react-redux';
import { MyContractorRouting } from '../../my-contractors/MyContractorsRouting';
import { CurrentUser } from '../model/CurrentUser';
import { MyOutsourcesRouting } from '../../my-outsources/MyOutsourcesRouting';
import { bindActionCreators } from 'redux';
import * as authActions from '../../login/actions/authActions';
import * as contractorsActions from '../../contractors/actions/contractorsActions';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { ContractorRouting } from '../../contractors/ContractorsRouting';
import { UsersRouting } from '../../users/UsersRouting';
import { AttachmentRouting } from '../../attachment/AttachmentRouting';
import { MainLayout } from '../components/layout/MainLayout';
import { AuthContext } from './AuthContext';
import { MessagesNotificationsRouting } from '../../messages-notifications/MessagesNotificationsRouting';
import { DocumentaryLibraryScreen } from '../../documentary-library/list/DocumentaryLibraryScreen';
import { DocumentaryLibraryCreateScreen } from '../../documentary-library/form/create/DocumentaryLibraryCreateScreen';

class Routing extends React.Component {

    componentDidMount() {
        const {
            user,
            authActions,
            contractorsActions,
        } = this.props;

        if ( !user ) {
            authActions.getUser();
            contractorsActions.fetchContractorCurrent();
        }
    }

    render() {
        const {
            history,
            currentUser,
            currentDataLoading,
        } = this.props;

        if ( currentDataLoading || currentUser.isNull() ) {
            const loadingStyle = {
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            };

            return (
                <div style={loadingStyle}>
                    <Loadable
                        active={true}
                        spinner
                        text={I18nUtils.tr('TR_CARGANDO')}
                        background={'rgba(255,255,255,.9)'}
                        color={'rgb(0,0,0)'}
                    />
                </div>
            );
        }

        return (
            <Router history={history}>
                <AuthContext.Provider value={{ currentUser }}>
                    <MainLayout>
                        <Route path="/" component={AlertComponent}/>
                        <Route path={PsRoutes.HOME} exact component={
                            currentUser.isListeriaManager() ? ProfileScreen : DashboardScreen
                        }/>
                        <Route path={PsRoutes.PROFILE} exact component={ProfileScreen}/>
                        <Route path={PsRoutes.PROFILE_PASSWORD_EDIT} exact component={ChangePasswordScreen}/>
                        <ContractorRouting currentUser={currentUser}/>
                        <UsersRouting currentUser={currentUser}/>
                        <MyContractorRouting currentUser={currentUser}/>
                        <MyOutsourcesRouting currentUser={currentUser}/>
                        <AttachmentRouting currentUser={currentUser}/>
                        <MessagesNotificationsRouting currentUser={currentUser}/>
                        <Route path={PsRoutes.DOCUMENTARY_LIBRARY} exact component={DocumentaryLibraryScreen}/>
                        <Route path={PsRoutes.DOCUMENTARY_LIBRARY_ADD} exact component={DocumentaryLibraryCreateScreen}/>
                    </MainLayout>
                </AuthContext.Provider>
            </Router>
        );
    }
}

const mapStateToProps = (state) => ( {
    currentUser: CurrentUser.fromReduxState(state),
    currentDataLoading: state.auth.loading || state.auth.contractorLoading,
} );

const mapDispatchToProps = dispatch => ( {
    authActions: bindActionCreators(authActions, dispatch),
    contractorsActions: bindActionCreators(contractorsActions, dispatch),
} );

export const AuthRouting = connect(mapStateToProps, mapDispatchToProps)(Routing);



// WEBPACK FOOTER //
// ./src/app/shared/routing/AuthRouting.jsx